import React from 'react';
import Segment from 'main/components/show/cuesheet/itemCell/segment.jsx';
import {
  EditableCellTypes,
  PlaceholderItemSegment,
  PlaceholderTitleRowItemSegment,
} from 'flux/stores/cuesheet/CuesheetConstants';
import classNames from 'classnames';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';

/**
 * Item Cell component (compact)
 *
 */
export default React.createClass({
  displayName: 'ItemCell',

  mixins: [HighlightCellMixin],

  propTypes: {
    user: React.PropTypes.object,
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    isCopied: React.PropTypes.bool,
    isTitleCopied: React.PropTypes.bool,
    checkSelectionStatus: React.PropTypes.func, //EditableCellType
    editing: React.PropTypes.string, //EditableCellType
    corrupted: React.PropTypes.bool, //EditableCellType
    rowType: React.PropTypes.string, //RowType
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    user: React.PropTypes.object.isRequired,
  },

  render() {
    const {
      checkSelectionStatus,
      editing,
      isCopied,
      item,
      isTitleCopied,
    } = this.props;

    let wrapperClasses = classNames('cs-item-cell-wrapper');

    let cellClasses = classNames(
      'cs-item-cell',
      'cs-cell',
      { 'cs-cell-copied': isCopied },
      this.getPersonalHighlightClass(),
    );

    let segmentPlaceholder = item.get('titleView')
      ? PlaceholderTitleRowItemSegment
      : PlaceholderItemSegment;

    return (
      <div className={wrapperClasses}>
        <div
          className={cellClasses}
          style={Object.assign(
            {},
            this.getGlobalHighlightStyle(),
            this.getPersonalHighlightStyle(),
          )}
        >
          <div className="cs-item-cell-content">
            <Segment
              {...this.props}
              className="cs-segment-container"
              isCopied={isTitleCopied}
              isSelected={checkSelectionStatus(EditableCellTypes.ItemTitle)}
              isEditing={editing === EditableCellTypes.ItemTitle}
              placeholder={segmentPlaceholder}
              titleFormat={item.get('titleFormat')}
              titleView={item.get('titleView')}
              title={item.get('title')}
            />
          </div>
        </div>
      </div>
    );
  },
});
